import React from "react";
import { Link } from "react-router-dom";
import { Home, TrendingUp, Users, PenTool, Shield, Bell, User, LogOut, LogIn, UserPlus, X } from "lucide-react";

interface MobileSidebarProps {
  open: boolean;
  onClose: () => void;
  isAuthenticated: boolean;
  isAdmin: boolean;
  onLogout: () => void;
}

const MobileSidebar: React.FC<MobileSidebarProps> = ({ open, onClose, isAuthenticated, isAdmin, onLogout }) => {
  return (
    <div className={`${open ? "fixed" : "hidden"} inset-0 z-50 sm:hidden`}>
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose} />
      <div className="absolute left-0 top-0 h-full w-64 bg-white border-r border-newspaper-300 flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-newspaper-300">
          <div
            style={{
              color: "#171717",
              fontSize: "18px",
              fontFamily: "Playfair Display",
              fontWeight: "600",
              wordWrap: "break-word",
            }}
          >
            Menu
          </div>
          <button onClick={onClose} className="text-newspaper-500 hover:text-newspaper-700 p-1">
            <X className="w-5 h-5" />
          </button>
        </div>
        <nav className="flex-1 overflow-y-auto p-2 space-y-1">
          <Link to="/" onClick={onClose} className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-newspaper-50">
            <Home className="w-4 h-4" />
            <span className="text-sm">FrontPage</span>
          </Link>
          {isAuthenticated && (
            <Link
              to="/the-edition"
              onClick={onClose}
              className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-newspaper-50"
            >
              <PenTool className="w-4 h-4" />
              <span className="text-sm">The Edition</span>
            </Link>
          )}
          <Link
            to="/thepulse"
            onClick={onClose}
            className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-newspaper-50"
          >
            <TrendingUp className="w-4 h-4" />
            <span className="text-sm">The Pulse</span>
          </Link>
          <Link
            to="/voices"
            onClick={onClose}
            className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-newspaper-50"
          >
            <Users className="w-4 h-4" />
            <span className="text-sm">Voices</span>
          </Link>
          {isAuthenticated && (
            <Link
              to="/write"
              onClick={onClose}
              className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-newspaper-50"
            >
              <PenTool className="w-4 h-4" />
              <span className="text-sm">Write</span>
            </Link>
          )}
          {isAdmin && (
            <Link
              to="/admin"
              onClick={onClose}
              className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-newspaper-50"
            >
              <Shield className="w-4 h-4" />
              <span className="text-sm">Admin</span>
            </Link>
          )}
          {isAuthenticated && (
            <Link
              to="/notifications"
              onClick={onClose}
              className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-newspaper-50"
            >
              <Bell className="w-4 h-4" />
              <span className="text-sm">Notifications</span>
            </Link>
          )}
          {isAuthenticated && (
            <Link
              to="/profile"
              onClick={onClose}
              className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-newspaper-50"
            >
              <User className="w-4 h-4" />
              <span className="text-sm">Profile</span>
            </Link>
          )}
          {isAuthenticated ? (
            <button
              onClick={() => {
                onLogout();
                onClose();
              }}
              className="w-full flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-red-50 text-red-600"
            >
              <LogOut className="w-4 h-4" />
              <span className="text-sm">Logout</span>
            </button>
          ) : (
            <div className="space-y-1">
              <Link
                to="/login"
                onClick={onClose}
                className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-newspaper-50"
              >
                <LogIn className="w-4 h-4" />
                <span className="text-sm">Login</span>
              </Link>
              <Link
                to="/register"
                onClick={onClose}
                className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-newspaper-50"
              >
                <UserPlus className="w-4 h-4" />
                <span className="text-sm">Register</span>
              </Link>
            </div>
          )}
        </nav>
      </div>
    </div>
  );
};

export default MobileSidebar;
